<template >
  <v-list-item v-on="rowClickEnabled && item.rowClick ? { click: item.rowClick } : {}">
    <v-list-item-content >
      <v-list-item-title>
        {{item.siteNotification.title}}</v-list-item-title>
      <v-list-item-subtitle>{{item.siteNotification.type | siteNotificationType}}  {{item.siteNotification.startTime | date}} - {{item.siteNotification.endTime | date}}</v-list-item-subtitle>
      <v-list-item-subtitle>{{item.siteNotification.active | siteNotificationActive }}</v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action v-if="showActions && !!item.rowActions && !!item.rowActions.length > 0">
      <entity-table-row-end-action-menu :actions="item.rowActions"/>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import EntityTableRowEndActionMenu from '@/components/entity-crud/EntityTableRowEndActionMenu';
export default {
  name: 'SiteNotificationListItem',
  components: { EntityTableRowEndActionMenu },
  props:{
    item:{
      type: Object,
      required: true,
      validator: item => {
          return  !!item.siteNotification;
      },
    },
    showActions:{
      type: Boolean,
    },
    rowClickEnabled:{
      type: Boolean,
    },
  },
  computed:{
  },
};
</script>

<style scoped>

</style>
